import { render, staticRenderFns } from "./PositionSelection.vue?vue&type=template&id=0a92f542&"
import script from "./PositionSelection.vue?vue&type=script&lang=ts&"
export * from "./PositionSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports